import spinnerReducer from './reducers';

export default spinnerReducer;
